import { Component, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MenuService } from "../../../services/menus/menu.service";
import { Subject, Subscription, takeUntil} from "rxjs";
import { combineLatestWith } from "rxjs/operators"
import { MessageService } from "primeng/api";
import { CurrencyModel } from "../../../models/menus/currency.model";
import { AuthenticationService} from "../../../../share-modul/services/authentication/authentication.service";
import { Location } from '@angular/common';
import { MenuAndCategoryDetailsModel } from "../../../models/menus/menu-and-category-details.model";
import { UserModel } from "../../../../share-modul/models/user/user.model";
import { RoleNameEnum } from "../../../../admin-panel/enums/role-name.enum";
import {
  CurrentVenueHelperService
} from "../../../../share-modul/services/current-venue-helper/current-venue.helper.service";

@Component({
  selector: 'app-menu-details',
  templateUrl: './menu-details.component.html',
  styleUrls: ['./menu-details.component.scss']
})
export class MenuDetailsComponent implements OnInit, OnDestroy {


  public menuId: string;
  public venueId: string | null;
  public currency: string;
  public menuModel: MenuAndCategoryDetailsModel = new MenuAndCategoryDetailsModel();
  public spinner: boolean;
  public unsubscribe: Subject<void> = new Subject<void>();
  public imagePath: string = './assets/images/logo/venue_logo_svg.svg';
  public user: UserModel;
  public authSubscription: Subscription;
  public venueIdUpdateSubscription: Subscription;
  public isAdminRoute: boolean =  false;
 

  constructor(public route: ActivatedRoute,
              public router: Router,
              public menuService: MenuService,
              public messageService: MessageService,
              private location: Location,
              public authenticationService: AuthenticationService,
              public currentVenueHelper: CurrentVenueHelperService,
              ) { }

  ngOnInit(): void {
    const obsCombined = this.route.params.pipe(combineLatestWith(this.route.data));
    obsCombined.subscribe(([params, data]) => {
      if(data['isAdminRoute']){
        this.isAdminRoute = true;
      }
      if (!this.isAdminRoute) {
        if (params['venue-id'] != null) {
          this.venueId = params['venue-id'];
          this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']); 
        }
      }
      this.menuId = params['id'];
      this.authSubscription = this.authenticationService.loginUser.subscribe(user => {
        if (user) {
          this.user = user!;
          this.loadMenuDetails();
        }
      });

      if(!this.isAdminRoute) {
       
      }
    })

  }

  
  private loadMenuDetails() {
    this.spinner = true;
    this.menuService.viewMenu(this.menuId, this.user.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.menuModel = response;
          if (this.user.roles.includes(RoleNameEnum.PosGeneralManager)) {
            this.fetchCurrencies();
          } else {
            this.getDefaultCurrency();
            this.spinner = false;
          }
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  private fetchCurrencies() {
    let companyId = this.authenticationService.getCompanyId();
    this.menuService.listCurrencies(companyId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.currency = response.find((x: CurrencyModel) => x.id === this.menuModel.defaultCurrencyId)?.symbol!;
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
        }
      });
  }
  public goBack(): void {
    this.location.back();
  }

  public getDefaultCurrency(): void {
    let companyId = this.authenticationService.getCompanyId();
    this.menuService.getDefaultCurrency(companyId, this.user.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.currency = response.symbol;
        }
      });
  }

  public ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
